export default __webpack_public_path__ + "static/media/file-type-doc-icon.a5fd0501.svg";